import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import clientsApi from "../../api/client/client";
import DataHandlerHelper from "../../helpers/DataHandler.helper";
import { localDayStartISO } from "../../helpers/dateFormat";
import { ui } from "../../helpers/ui";

const InitStopClientLogic = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<any>({
    client: "",
    fromDate: "",
    toDate: "",
  });
  const [clients, setClients] = useState<any[]>([]);
  const [selectedClients, setSelectedClients] = useState<any[]>([]);

  const loadClients = () => {
    clientsApi
      .getAll()
      .then((response) => {
        if (response.status === 200) {
          setClients(response.data);
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onSave = async () => {
    if (selectedClients.length === 0) {
      ui.alert("Izaberite bar jednog klijenta.");
      return;
    }
    if (new Date(data.fromDate).toString() === "Invalid Date") {
      ui.alert("Neispravan datum Od");
      return;
    }
    if (new Date(data.toDate).toString() === "Invalid Date") {
      ui.alert("Neispravan datum Do");
      return;
    }
    const confirmed = await ui.confirm("Sigurno želite da sačuvate?");
    if (!confirmed) return;
    clientsApi
      .stop({
        selectedClients: selectedClients,
        fromDate: localDayStartISO(data.fromDate),
        toDate: localDayStartISO(data.toDate),
      })
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          ui.toast("Sačuvano", "success");
          navigate("/home");
        }
      })
      .catch((e) => {
        ui.alert(e.response?.data?.error?.message || "Greška");
      });
  };

  const onChange = (event: any) => {
    setData(DataHandlerHelper.handleInputChange(event, { ...data }));
  };

  const addClient = (client: any) => {
    // Zaštita od duplog klika: bez mutacije state niza i bez duplikata
    if (selectedClients.some((c: any) => c.id === client.id)) return;
    setClients(clients.filter((c: any) => c.id !== client.id));
    setSelectedClients([...selectedClients, client]);
    setData({ ...data, client: "" });
  };

  const removeSelectedClient = (client: any) => {
    if (!selectedClients.some((c: any) => c.id === client.id)) return;
    setSelectedClients(selectedClients.filter((c: any) => c.id !== client.id));
    setClients([...clients, client]);
  };

  useEffect(() => {
    loadClients();
  }, []);

  return {
    selectedClients,
    clients,
    data,
    onSave,
    onChange,
    addClient,
    removeSelectedClient,
  };
};

export default InitStopClientLogic;
